import { getBlob, ref } from "firebase/storage";
import { storage } from "./firebase";
import { EMAIL_SCANNER_EXTENSION } from "./projectSettings";

export async function downloadEmailScannerExtension() {
  const blob = await getBlob(ref(storage, EMAIL_SCANNER_EXTENSION.storagePath));
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = EMAIL_SCANNER_EXTENSION.archiveName;
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}
